export default __webpack_public_path__ + "static/media/anyni4.30612639.jpeg";